// extracted by mini-css-extract-plugin
module.exports = {"top":"Home_top__1bXtG","bottom":"Home_bottom__13cfx"};